export default "__VITE_ASSET__PAc4$rVW__"